export const DialogTypes = {
  PLAYLIST: 'playlist',
} as const;

export type DialogTypes = (typeof DialogTypes)[keyof typeof DialogTypes];
